module.exports = __webpack_public_path__ + "img/refund.1ca0a363.svg";